import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import '../../css/Buttons.css';
import {config} from '../../constants';
import CircleSign from '../ui/CircleSign';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import {exportToExcel} from '../../utils/exportMethods'; 
import {deleteKey} from '../../utils/exportMethods';
import ConfirmationModal from '../ui/ConfirmationModal';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL;
const dataSource = createStore({
  key: "geoElementId",
  loadUrl: `${url}/GeoElementMicroservice/zone`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/GeoElementMicroservice`, 
  onBeforeSend: (method, ajaxOptions) => {
     ajaxOptions.headers = {  
     'accept': 'application/json',
     'Authorization': 'Bearer '+localStorage.getItem('token')
  }  
   },
   onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const appName = "";//ArchicubedWeb; //Production
const LoadSubmenu = (section) =>{
  history.push(appName+'/admin' + (section != '' ? '/'+section : '')) ;
}

const exportZonesToExcel = async (apiData) => {
  apiData.forEach(obj => {
    deleteKey(obj, 'geoElementId');
    deleteKey(obj, 'level');
    deleteKey(obj, 'zoneName');
    deleteKey(obj, 'subZoneName');
    deleteKey(obj, 'subZoneGeoElementId');
    deleteKey(obj, 'zoneGeoElementId');
  });

  const headers = [
    { header: 'Zone', key: 'name', autoFit: true },
    { header: 'Status', key: 'isEnabled', autoFit: true }
  ];

  await exportToExcel(headers, apiData, 'zones_extract', 'Zones Extract');
};

class Zone extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];

      this.state = {
        showFilterRow: true,
        showHeaderFilter: false,
        currentFilter: this.applyFilterTypes[0].key,
        showColumnLines: false,
        showRowLines: true,
        showBorders: true,
        rowAlternationEnabled: true,
        showModal: false,
        showEditModal: false,
        showConfirmationModal: false,
        showCountryMenu: true,
        showZoneMenu: true,
        showSubZoneMenu: true,
        fullscreen:false,
        oldCheckValue: false,
        validation: true,
        duplicatedValidation:true,
        selectedRowName:"",       
      };

      this.dataGrid = null;
      this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
      this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
      this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
      this.zoneName = React.createRef();
      this.zoneName_Edit = React.createRef();
      this.zoneIsEnabled = React.createRef();
      this.confDiag = React.createRef();
    }

    fullscreenHandler=()=>{
      this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
    }

    selectedChanged(e) {
      this.setState({
        selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
      });
    }

  // to refresh our datagrid table and close all modals
  useRefresh = () => {
    this.dataGrid.useRefresh();
      this.setState({
        showModal: false,
        showEditModal: false,
        showConfirmationModal: false,
      });
    }
  handleClose = () =>{
    this.setState({ showConfirmationModal: true });
  }

  closeConfirmationModal = ()=>{
    this.setState({ showConfirmationModal: false });
  }

  doubleCloseModals=()=>{
    this.setState({showModal: false, showEditModal: false, showConfirmationModal:false});
  }

  handleEditClose = () =>{
      this.setState({ showConfirmationModal: true });
  }

  openModal = () => {   
    this.setState({showModal:true, duplicatedValidation: true ,
      validation:true});
  }
  
  onExportToExcel = () => {
    apiClient.get(`${url}/GeoElementMicroservice/zone`)
      .then(response => {
        const data = response.data;
        if (data) {
          exportZonesToExcel(data);
          toast.success('Zones Excel export file has been generated');
        }
      });
  }

  onCreateZone = () => {
    this.setState({duplicatedValidation: true})
    let name = this.zoneName.current.value.trim();

    if (name == ""){
      this.setState({validation: false})
      return;
    }else{
      this.setState({validation: true})
    }

    let zone = {
      Name: name,
      IsEnabled: true
    };

    apiClient.post(`${url}/GeoElementMicroservice/zone`, zone)
      .then(response => {
        const data = response.data;
        if (data) {
          if (data.status == 400 || data.statusCode == 400) {
            this.setState({ duplicatedValidation: false })
            return;
          } else {
            toast.success("Zone has been created");
            this.doubleCloseModals();
            this.useRefresh();
          }
        }
      }); 
  }

  showEditSuccessToast = () => {
    toast.success('Zone has been updated');
  }

  showDisabledEnabledToast = (value) => {
    if(!this.confDiag.current.state.inEditMode) {
      if(!value) {
        toast.success('Zone has been enabled');
      }
      else {
        toast.success('Zone has been disabled');
      }
    }
    else {
      if(value) {
        toast.success('Zone has been enabled');
      }
      else {
        toast.success('Zone has been disabled');
      }
    }
  }

  openEditModal = (e) => {      
    const zoneId = e.row.key;
    const zoneName = e.row.data.name.trim();
    console.log(zoneName)
    this.setState({duplicatedValidation: true,showEditModal:true,  validation:true});
    this.setState({selectedRowIndex: zoneId, selectedRowName : zoneName});
    const zone = e.row.data;
    this.zoneName_Edit.current.value = zone.name;
    this.zoneIsEnabled.current.checked = zone.isEnabled;
    this.setState({oldCheckValue: zone.isEnabled});
  }

  onEditZone = (e) => {
    const zoneId = this.state.selectedRowIndex;
    let name = this.zoneName_Edit.current.value.trim();
    this.setState({ duplicatedValidation: true })

    if (name == "") {
      this.setState({ validation: false })
      return;
    } else {
      this.setState({ validation: true })
    }

    const zone = {
      geoElementId: zoneId,
      Name: name,
      IsEnabled: this.state.oldCheckValue
    };

    apiClient.put(`${url}/GeoElementMicroservice`, zone)
      .then(response => {
        const data = response.data;
        if (data) {
          if (data.status == 400 || data.statusCode == 400) {
            this.setState({ duplicatedValidation: false })
            return;
          } else {
            if (this.state.oldCheckValue != this.zoneIsEnabled.current.checked) {
              this.confDiag.current.state.status = this.zoneIsEnabled.current.checked
              this.confDiag.current.state.inEditMode = true;
              this.confDiag.current.state.key = this.state.selectedRowIndex;
              this.confDiag.current.handleOpenConfirmDialog();
            } else {
              toast.success("Zone has been updated");
              this.doubleCloseModals();
              this.useRefresh();
            }
          }
        }
      })
  }

  onDeleteZone = (e) => {
    const zone = e.row.data;
    apiClient.delete(`${url}/GeoElementMicroservice`.concat("/").concat(zone.geoElementId), { method: 'deleteGeoElement' })
      .then(response => {
        const data = response.data;
        if (data.statusCode == 400) {
          this.setState({ duplicatedValidation: false })
          return;
        } else {
          if (data && data.statusCode == 200) {
            toast.success("Zone has been deleted");
          } else toast.error("Error " + response.statusCode);
        }
      });
  }

  componentDidMount() {
    const decoded = jwt_decode(localStorage.getItem('token'));
  this.setState({
    showCountryMenu: decoded.can_manage_country === "true",
    showZoneMenu: decoded.can_manage_zone === "true",
    showSubZoneMenu: decoded.can_manage_subzone === "true",
    can_export_to_excel: decoded.can_export_to_excel === "true"
  });
  }
  
      Checkisenabled = (e) =>{
        return e.row.data.isEnabled ;
    }
      Checkisdisabled = (e) =>{
      return !e.row.data.isEnabled ;
    }
    onDelete = (e) => {
      this.confDiag.current.state.key = e.row.data.geoElementId;  
      this.confDiag.current.state.status = e.row.data.isEnabled;
      this.confDiag.current.state.inEditMode = false;
      this.confDiag.current.handleOpenConfirmDialog();
    }
  render() {

    const columns = [
      { dataField: "isEnabled", caption: "Status", width: "110" },
      { dataField: "name", caption: "Zone", width: "100%"},
      // Add other columns specific to Profiles component
    ];

    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDelete},
      {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDelete},
      // Additional buttons for Profiles component
    ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>            
           {'Geography > Zones Management'}
          </span>
        </div>
        <div className="div-section-actions push">
          <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header"  onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Zone</label>
          </button>
        </div>
        </div>
        <div className="div-body-section-details-body">
        <div className="div-body-submenu">
          <div className={this.state.showZoneMenu ? "div-submenu-link active" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('zones')} >              
             <div class="div-submenu-label">
                    <label>Zones</label>
                </div> 
                            
            </div>
            <div className={this.state.showSubZoneMenu ? "div-submenu-link" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('subzones')} >              
             <div class="div-submenu-label">
                    <label>Subzones</label>
                </div> 
                            
            </div>
            <div className={this.state.showCountryMenu ? "div-submenu-link" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('countries')} >              
             <div class="div-submenu-label">
                    <label>Country/Region</label>
                </div> 
                            
            </div>
          </div>
        <div  className="div-padding-20 div-grid-result">

        <CustomDataGrid
              dataSource={dataSource}
              keyExpr="zoneId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              onSelectionChanged={this.selectionChanged}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>
      </div>

      <Modal show={this.state.showModal} onHide={this.handleClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >New Zone</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Zone already exists, your updates cannot be saved. Please go back to Zones Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Zone form is not allowed</p></Row>  }

          <Row>    
              <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.validation ? "normal-title" : "validation-title"}`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref={this.zoneName}      placeholder="Name" className={`${!this.state.validation && "validation-control"}`}/>
              {!this.state.validation && <p className="p-required">Required</p>}
              </Form.Group>
              </Row>     
          
      </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateZone}>
            Create Zone
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6">Edit Zone</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Zone already exists, your updates cannot be saved. Please go back to Zones Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Zone form is not allowed</p></Row>  }
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.validation ? "normal-title" : "validation-title"}`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref={this.zoneName_Edit} placeHolder="Name" className={`${!this.state.validation && "validation-control"}`} />
              {!this.state.validation && <p className="p-required">Required</p>}

              <br/>
              <Form.Check type="checkbox" label="Is Enabled" ref={this.zoneIsEnabled}/>
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditZone}>
            Update Zone
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>

      <ConfirmDialog ref={this.confDiag} microserviceName="GeoElementMicroservice" refreshfunction={this.useRefresh} editfunction={this.showDisabledEnabledToast} title="Error" msg="You can't disable this Zone because it is still linked to enabled Subzones. Please disable Subzones first."></ConfirmDialog>
      <ToastContainer position="bottom-right"/>  
      </div>
    );
  }
  onShowFilterRowChanged(e) {
    this.setState({
      showFilterRow: e.value
    });
    this.clearFilter();
  }
  onShowHeaderFilterChanged(e) {
    this.setState({
      showHeaderFilter: e.value
    });
    this.clearFilter();
  }
  onCurrentFilterChanged(e) {
    this.setState({
      currentFilter: e.value
    });
  }
  clearFilter() {
    this.dataGrid.clearFilter();
  }
}

export default Zone;
